import HttpRequest from "./HttpRequest";

export default new HttpRequest(process.env.VUE_APP_BASE_URL)